import {Renderer, Component, Input ,Output,EventEmitter,OnInit, AfterViewInit,AfterViewChecked, ViewChild, ElementRef} from '@angular/core';
import { NgbActiveModal, NgbModal,NgbModule  } from '@ng-bootstrap/ng-bootstrap';
import { callbackify } from 'util';

declare var $ : any;
import * as moment from 'moment';

import {SearchPipe} from '../../../pipes/search';

import {ContactDbService} from  '../../../services/contactdb.service';
import { ToastrService } from 'ngx-toastr';
import { Router,ActivatedRoute } from '@angular/router';

import {FormControl} from '@angular/forms';


@Component({
  selector: 'ngbd-modal-basic',
  templateUrl: './invite_modal.component.html'
})
export class NgbdModalBasic implements AfterViewInit,OnInit{



 // @ViewChild('addemail', {static: false}) addemail:ElementRef;

 

 public addemail:string='';

 public countrySrh:string='';

 public companySrh:string='';

 public jobTitleSrh:string='';

 public tagsSrh:string='';
 
 public groupSrh:string='';

 filternameas:any='';

 filterNameList:any;

 filterUpdate:any='';


 time:any = {hour: moment().hour(), minute: moment().minute()};

 meridian = true;

 adddate:any='';

 fromName:any='';

 fromEmail:any='';

 showFrom:boolean=false;

 filterby:any='';

 appliedFilterId:any;

 isfilterUpdated:boolean=false;

 isFilterChange:boolean=false;

 searchInvite:any;

 
  @Input() year;
  @Input() month;
  @Input() newsletterI;
  @Input() finalShare:boolean=false;
  @Input() UShare:boolean=false;
  
  loader_image:boolean=true;


  selectedCountry = []
  selectedCompany = []
  selectedJob =  []
  selectedTag = []
  selectedGroup = []

  invite:Array<string>=[];

  countries:Array<any>=[];

  companies:Array<any>=[];

  job_titles:Array<any>=[];

  tags:Array<any>=[];

  groups:Array<any>=[];

  assigned:Array<any>=[ {'countries':[],'companies':[],'job_titles':[],'tags':[],'groups':[] }];

  timeout: any;

  config2: any = {'class': 'test','placeholder': 'Search Contacts'};
  isDisplay:boolean =false
  isClose:boolean =false
  isEnterPressed:boolean =false


  inviteName:Array<string>=[];
  inviteEmail:Array<string>=[];
  searchValue:any=''

  conditionList=["OR","AND","NOT"];
  Condition:any={
    "Country":"OR",
    "Company":"OR",
    "Job Title":"OR",
    "Tags":"OR",
    "Groups":"OR"
  };
  selectedConditionCompany:any='OR';
  selectedConditionCountry:any='OR';
  selectedConditionJob:any='OR';
  selectedConditionTag:any='OR';
  selectedConditionGroup:any='OR';
  countryLength:any;
  companyLength:any;
  jobLength:any;
  tagLength:any;
  groupLength:any;


  constructor( public _router: Router,public toastr: ToastrService,public cd:ContactDbService,public activeModal: NgbActiveModal ,private render:Renderer) {

  }

  
  @Output() passEntry: EventEmitter<any> = new EventEmitter();


  get_name(name:string){

     return name.match(/^([^@]*)@/)[1];
  }

 


 ValidateEmail(mail) 
{
 if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail))
  {
    return (true)
  }
 
    return (false)
}



seachContact(){

  let country = [];

  this.assigned[0].countries.forEach( (items)=>{
    if(items.tid!=undefined || items.tid!=null){
      country.push(items.tid);
    }
  });

  


  let company =  [];

  this.assigned[0].companies.forEach( (items)=>{
    if(items.tid!=undefined || items.tid!=null){
      company.push(items.tid);
    }
  });

  
  let job_title = [];

  this.assigned[0].job_titles.forEach( (items)=>{
    if(items.tid!=undefined || items.tid!=null){
      job_title.push(items.tid);
    }
  });

  


  let tag =  [];

  this.assigned[0].tags.forEach( (items)=>{
    if(items.tid!=undefined || items.tid!=null){
      tag.push(items.tid);
    }
  });


  let group =  [];

  this.assigned[0].groups.forEach( (items)=>{
    if(items.tid!=undefined || items.tid!=null){
      group.push(items.tid);
    }
  });



  let records =  {
     "Country":country,
     "Company":company,
     "Job Title":job_title,
     "Groups":group,
     "Tags":tag,
     "Search":this.searchInvite,
     "Condition":this.Condition
 
     
   };

  
 
  

   try{

    let tokenA:any = (localStorage.getItem('token')!=undefined )?atob(localStorage.getItem('token')): 0;

    if(!tokenA) throw 'Error in parse';
    
    if(!JSON.parse(tokenA)) throw 'Error in json parse';

    tokenA = JSON.parse(tokenA);
        
    this.cd.filterContact({'token':tokenA.token,'details':records}).subscribe( (res)=>{

     
        if(res!=null && res!=undefined){

          if(res.length > 0){

            this.inviteEmail =[]

            this.invite =res;
               
            res.map((x)=>{
             
              this.inviteEmail.push(x.email)
            })
           
            this.toastr.success('Contact Replaced', '', {timeOut: 3000});
          }else{

            this.invite =[];
            
            this.inviteEmail =[];


            this.toastr.success('No Contact Found', '', {timeOut: 3000});

          }
          
        } else{
              
          this.invite =[];
         
          this.inviteEmail =[];

          
          this.toastr.error('Error in Record Fetch  !', '', {timeOut: 3000});

        }

      
      



     });



  }catch(e){


     this.toastr.success('Unauthorized Access  !', '', {timeOut: 3000});
     this._router.navigate(['/login']);
  }


}

addContact(){

  let country = [];

  this.assigned[0].countries.forEach( (items)=>{
    if(items.tid!=undefined || items.tid!=null){
      country.push(items.tid);
    }
  });

  


  let company =  [];

  this.assigned[0].companies.forEach( (items)=>{
    if(items.tid!=undefined || items.tid!=null){
      company.push(items.tid);
    }
  });

  
  let job_title = [];

  this.assigned[0].job_titles.forEach( (items)=>{
    if(items.tid!=undefined || items.tid!=null){
       job_title.push(items.tid);
    }
  });

  


  let tag =  [];

  this.assigned[0].tags.forEach( (items)=>{
    if(items.tid!=undefined || items.tid!=null){
      tag.push(items.tid);
    }
  });


  let group =  [];

  this.assigned[0].groups.forEach( (items)=>{
    if(items.tid!=undefined || items.tid!=null){
      group.push(items.tid);
    }
  });


  let records =  {
     "Country":country,
     "Company":company,
     "Job Title":job_title,
     "Groups":group,
     "Tags":tag,
     "Search":this.searchInvite,
     "Condition":this.Condition
 
     
   };

  
 
  

   try{

    let tokenA:any = (localStorage.getItem('token')!=undefined )?atob(localStorage.getItem('token')): 0;

    if(!tokenA) throw 'Error in parse';
    
    if(!JSON.parse(tokenA)) throw 'Error in json parse';

    tokenA = JSON.parse(tokenA);
        
    this.cd.filterContact({'token':tokenA.token,'details':records}).subscribe( (res)=>{

     
        if(res!=null && res!=undefined){

          if(res.length > 0){

            res.map((x)=>{
             
              this.inviteEmail.push(x.email)
            })

            let a= this.inviteEmail
           
            let uniqueArray = a.filter(function(item, pos) {
              return a.indexOf(item) == pos;
            })
            this.inviteEmail = uniqueArray
            this.toastr.success('Contact Added', '', {timeOut: 3000});
            // console.log('ranjit',this.inviteEmail,res)
          }else{

            this.toastr.success('No Contact Found', '', {timeOut: 3000});

          }
          
        } else{
         
          this.toastr.error('Error in Record Fetch  !', '', {timeOut: 3000});

        }

      
      



     });



  }catch(e){


     this.toastr.success('Unauthorized Access  !', '', {timeOut: 3000});
     this._router.navigate(['/login']);
  }


}


resetContact(){

  this.invite =[];
  this.inviteName =[];
  this.inviteEmail =[];

  
}


searchPersons(item: any){  

  if(item==1){
    this.searchInvite = this.searchValue
  }else{
    this.searchInvite = item
  }


  this.isDisplay = true
  this.isClose = true



  let country = [];

  this.assigned[0].countries.forEach( (items)=>{
    if(items.tid!=undefined || items.tid!=null){
      country.push(items.tid);
    }
  });


  let company =  [];

  this.assigned[0].companies.forEach( (items)=>{
    if(items.tid!=undefined || items.tid!=null){
      company.push(items.tid);
    }
  });

  
  let job_title = [];

  this.assigned[0].job_titles.forEach( (items)=>{
    if(items.tid!=undefined || items.tid!=null){
      job_title.push(items.tid);
    }
  });


  let tag =  [];

  this.assigned[0].tags.forEach( (items)=>{
    if(items.tid!=undefined || items.tid!=null){
      tag.push(items.tid);
    }
  });


  let group =  [];

  this.assigned[0].groups.forEach( (items)=>{
    if(items.tid!=undefined || items.tid!=null){
      group.push(items.tid);
    }
  });

  let records =  {
     "Country":country,
     "Company":company,
     "Job Title":job_title,
     "Groups":group,
     "Tags":tag,
     "Search":this.searchInvite,
     "Condition":this.Condition
 
     
   };


   try{

    let tokenA:any = (localStorage.getItem('token')!=undefined )?atob(localStorage.getItem('token')): 0;

    if(!tokenA) throw 'Error in parse';
    
    if(!JSON.parse(tokenA)) throw 'Error in json parse';

    tokenA = JSON.parse(tokenA);
        
    this.cd.filterContact({'token':tokenA.token,'details':records}).subscribe( (res)=>{
     
      

        if(res!=null && res!=undefined){

          if(res.length > 0){

            this.inviteEmail =[];

            res.map((x)=>{
             
              this.inviteEmail.push(x.email)
            })
          
            this.toastr.success('Record Found  !', '', {timeOut: 3000});
          }else{

            this.inviteEmail =[];
            this.toastr.warning('Record Not Found  !', '', {timeOut: 3000});

          }
          
        } else{
              
         
          this.inviteEmail =[];
     
          this.toastr.warning('Error in Record Fetch  !', '', {timeOut: 3000});

        }

     });



  }catch(e){


     this.toastr.success('Unauthorized Access  !', '', {timeOut: 3000});
     this._router.navigate(['/login']);
  }

  
}

clearSearch(){
  this.searchInvite = ''
  this.isClose = false
  this.isDisplay = false
  this.inviteName =[];
  this.inviteEmail =[];
  this.searchValue = ''
}



onSearchChange(searchValue: string): void {

  

  $(".test").keypress(e=>{
    if(e.keyCode == 13 && !e.shiftKey){
      e.preventDefault();
      this.isEnterPressed =true
      
    }else{
      this.isEnterPressed =false
    }
  })
  


  if(searchValue){
    this.isDisplay = true
    this.isClose = true
  }else{
    this.isDisplay = false
    this.isClose = false
    
  }
 
  clearTimeout(this.timeout);

  this.timeout = setTimeout( () =>{ 

     if(this.isEnterPressed){
      this.searchPersons(searchValue)
     }
    
    let country = [];

    this.assigned[0].countries.forEach( (items)=>{
  
        country.push(items.tid);
    });
  
  
    let company =  [];
  
    this.assigned[0].companies.forEach( (items)=>{
  
        if(items.tid!=undefined || items.tid!=null){
          company.push(items.tid);
        }
        
    });
  
    
    let job_title = [];
  
    this.assigned[0].job_titles.forEach( (items)=>{
      if(items.tid!=undefined || items.tid!=null){
         job_title.push(items.tid);
      }
    });
  
  
    let tag =  [];
  
    this.assigned[0].tags.forEach( (items)=>{
      if(items.tid!=undefined || items.tid!=null){
        tag.push(items.tid);
      }
    });
  
  
    let group =  [];
  
    this.assigned[0].groups.forEach( (items)=>{
      if(items.tid!=undefined || items.tid!=null){
        group.push(items.tid);
      }
    });


    this.searchValue = searchValue
  
    let records =  {
       "Country":country,
       "Company":company,
       "Job Title":job_title,
       "Groups":group,
       "Tags":tag,
       "Search":searchValue,
       "Condition":this.Condition
   
       
     };
  
   

     try{
  
      let tokenA:any = (localStorage.getItem('token')!=undefined )?atob(localStorage.getItem('token')): 0;
  
      if(!tokenA) throw 'Error in parse';
      
      if(!JSON.parse(tokenA)) throw 'Error in json parse';
  
      tokenA = JSON.parse(tokenA);
          
      this.cd.filterContact({'token':tokenA.token,'details':records}).subscribe( (res)=>{
  
       
          if(res!=null && res!=undefined){
  
            if(res.length > 0){

              this.inviteName = []
  
             res.map((x)=>{
               this.inviteName.push(x.name)
               
             })
            
  
            }else{
  
              // this.toastr.success('Record Not Found  !', '', {timeOut: 3000});
  
            }
            
          } else{
                
            
            this.toastr.success('Error in Record Fetch  !', '', {timeOut: 3000});
  
          }
  
       });
  
  
  
    }catch(e){
  
  
       this.toastr.success('Unauthorized Access  !', '', {timeOut: 3000});
       this._router.navigate(['/login']);
    }


  }, 1000);

  
  
}



  add_email(email:string){

    let emails:any = $.trim(email);

    if(this.ValidateEmail(emails) ){

      this.invite.push(emails);

      this.inviteEmail.push(emails);

     // this.addemail.nativeElement.value = '';

     this.addemail = '';

     this.inviteEmail = [...new Set(this.inviteEmail)];

     this.invite = [...new Set(this.invite)];

    }

    

  }

  remove_email(index:number){

    this.invite.splice(index,1);
    this.inviteEmail.splice(index,1);

  }


  

  addClassDyn(type:string,tid:number){

  switch(type){
   
    case 'countries':

     return (this.assigned[0].countries.findIndex( (item) => { return item.tid == tid;} ) == -1) ? false :true;
         

    break;


    case 'groups':

    return (this.assigned[0].groups.findIndex( (item) => { return item.tid == tid;} ) == -1) ? false :true;
            
   
    break;

    case 'companies':

    return (this.assigned[0].companies.findIndex( (item) => { return item.tid == tid;} ) == -1) ? false :true;
              
     
    break;

    case 'tags':

    return (this.assigned[0].tags.findIndex( (item) => { return item.tid == tid;} ) == -1) ? false :true;
                  
         
    break;

    case 'job_titles':

    return (this.assigned[0].job_titles.findIndex( (item) => { return item.tid == tid;} ) == -1) ? false :true;
                  
         
    break;
    

        




  }


  }


  clearAll(){

     this.assigned =[ {'countries':[],'companies':[],'job_titles':[],'tags':[],'groups':[] }];

      
    this.groups.forEach(obj => {

          $('#groups_'+obj.tid).removeClass('active_t');

    });

    this.tags.forEach(obj => {
  
          $('#tags_'+obj.tid).removeClass('active_t');

    });


    this.job_titles.forEach(obj => {

       $('#job_title_'+obj.tid).removeClass('active_t');
    
    });

    this.countries.forEach(obj => {

        $('#country_'+obj.tid).removeClass('active_t');
        

    });

    this.companies.forEach(obj => {
      
          $('#company_'+obj.tid).removeClass('active_t');

        
    });





  }



  removeGroups(event:any,tid:number){


    event.preventDefault();

    
    let p = this.assigned[0].groups.filter( (item)=> { return item.tid != tid}); 

    let pI = this.assigned[0].groups.find( (item)=> { return item.tid == tid}); 

 
    this.groups.forEach(obj => {

      if(obj.tid == pI.tid){

          $('#groups_'+pI.tid).removeClass('active_t');

        
      }

    });

    let index = this.assigned[0].groups.findIndex(x => x.tid ==tid);
    
    this.assigned[0].groups = p;
    if(this.assigned[0].groups.length>0){
      if(index>0){
        this.assigned[0].groups.splice(index-1, 1);
      }else{
        if(this.assigned[0].groups[0] && this.assigned[0].groups[0]['id']!=undefined){
           this.assigned[0].groups.shift();
        }
      }
    }
    
    this.groupLength = this.groupLength-1

    

    if(this.filterby!=undefined && this.assigned[0].groups.length==this.selectedGroup.length){
      this.isFilterChange =false
    }else if(this.filterby!=undefined && this.assigned[0].groups.length>0){
      this.isFilterChange =true
    } 
    if(this.assigned[0].groups.length==0){
      this.Condition['Groups']='OR'
    }


  }


  removeTags(event:any,tid:number){

   
    event.preventDefault();


    let p = this.assigned[0].tags.filter( (item)=> { return item.tid != tid}); 

    let pI = this.assigned[0].tags.find( (item)=> { return item.tid == tid}); 


 
    this.tags.forEach(obj => {

      if(obj.tid == pI.tid){

          $('#tags_'+pI.tid).removeClass('active_t');

        
      }

    });

    let index = this.assigned[0].tags.findIndex(x => x.tid ==tid);
    
    this.assigned[0].tags = p;
    if(this.assigned[0].tags.length>0){
      if(index>0){
        this.assigned[0].tags.splice(index-1, 1);
      }else{
        if(this.assigned[0].tags[0] && this.assigned[0].tags[0]['id']!=undefined){
           this.assigned[0].tags.shift();
        }
      }
    }
    
    this.tagLength = this.tagLength-1

   

    if(this.filterby!=undefined && this.assigned[0].tags.length==this.selectedTag.length){
      this.isFilterChange =false
    }else if(this.filterby!=undefined && this.assigned[0].tags.length>0){
      this.isFilterChange =true
    }

    if(this.assigned[0].tags.length==0){
      this.Condition['Tags']='OR'
    }

  }

  removeJobTitles(event:any,tid:number){


    event.preventDefault();

   

    let p = this.assigned[0].job_titles.filter( (item)=> { return item.tid != tid}); 

    let pI = this.assigned[0].job_titles.find( (item)=> { return item.tid == tid}); 

 
    this.job_titles.forEach(obj => {

      if(obj.tid == pI.tid){

          $('#job_title_'+pI.tid).removeClass('active_t');

        
      }

    });

    let index = this.assigned[0].job_titles.findIndex(x => x.tid ==tid);
    
    this.assigned[0].job_titles = p;
    if(this.assigned[0].job_titles.length>0){
      if(index>0){
        this.assigned[0].job_titles.splice(index-1, 1);
      }else{
        if(this.assigned[0].job_titles[0] && this.assigned[0].job_titles[0]['id']!=undefined){
           this.assigned[0].job_titles.shift();
        }
      }
    }
    
    this.jobLength = this.jobLength-1

    if(this.filterby!=undefined && this.assigned[0].job_titles.length==this.selectedJob.length){
      this.isFilterChange =false
    }else if(this.filterby!=undefined && this.assigned[0].job_titles.length>0){
      this.isFilterChange =true
    }
    if(this.assigned[0].job_titles.length==0){
      this.Condition['Job Title']='OR'
    }

  }

 
  removeCountries(event:any,tid:number){

    event.preventDefault();

    let p = this.assigned[0].countries.filter( (item)=> { return item.tid != tid}); 

    let pI = this.assigned[0].countries.find( (item)=> { return item.tid == tid}); 

    this.countries.forEach(obj => {

      if(obj.tid == pI.tid){

          $('#country_'+pI.tid).removeClass('active_t');

        
      }

    });

    let index = this.assigned[0].countries.findIndex(x => x.tid ==tid);
    
    
    this.assigned[0].countries = p;
    if(this.assigned[0].countries.length>0){
     
      if(index>0){
        this.assigned[0].countries.splice(index-1, 1);
      }else{
        if(this.assigned[0].countries[0] && this.assigned[0].countries[0]['id']!=undefined){
           this.assigned[0].countries.shift();
        }
      }
    }
    
    this.countryLength = this.countryLength-1


    if(this.filterby!=undefined && this.assigned[0].countries.length==this.selectedCountry.length){
      this.isFilterChange =false
    }else if(this.filterby!=undefined && this.assigned[0].countries.length>0){
      this.isFilterChange =true
    }
    if(this.assigned[0].countries.length==0){
      this.Condition['Country']='OR'
    }
   
  }


  removeCompanies(event:any,tid:number){

    event.preventDefault();

    

    let p = this.assigned[0].companies.filter( (item)=> { return item.tid != tid}); 

    let pI = this.assigned[0].companies.find( (item)=> { return item.tid == tid}); 

    this.companies.forEach(obj => {

      if(obj.tid == pI.tid){

          $('#company_'+pI.tid).removeClass('active_t');

        
      }

    });

    let index = this.assigned[0].companies.findIndex(x => x.tid ==tid);
    
    
    this.assigned[0].companies = p;
    if(this.assigned[0].companies.length>0){
      if(index>0){
        this.assigned[0].companies.splice(index-1, 1);
      }else{
        if(this.assigned[0].companies[0] && this.assigned[0].companies[0]['id']!=undefined){
           this.assigned[0].companies.shift();
        }
      }
      
      
      
    }
    
    if(this.filterby!=undefined && this.assigned[0].companies.length==this.selectedCompany.length){
      this.isFilterChange =false
    }else if(this.filterby!=undefined && this.assigned[0].companies.length>0){
      this.isFilterChange =true
    }
    this.companyLength=this.companyLength-1


    if(this.assigned[0].companies.length==0){
      this.Condition['Company']='OR'
    }
    
   
  }



  saveGroup(event:any,tid:number){

    this.Condition['Groups']=this.selectedConditionGroup

    if(this.filterby!=undefined){
      this.isFilterChange =true
    }
    if(this.assigned[0].groups.length>0){
      let obj={
        id:this.assigned[0].groups.length,
        name:this.selectedConditionGroup
      }
      this.assigned[0].groups.push(obj)
    }
    event.preventDefault();

    this.render.setElementClass(event.target,"active_t",true);

    let group = this.groups.find( (item) => { return item.tid ==tid});

    let group_index = this.assigned[0].groups.findIndex( (item)=> { return item.tid == group.tid}); 
    
    if(group_index == -1){

      this.assigned[0].groups.push(group);
    }

    let filter = this.assigned[0].groups.filter( (item) => { 
      return (item.name =='OR' || item.name =='AND' || item.name =='NOT')
    });
    this.groupLength=filter.length+1


  }

  saveTag(event:any,tid:number){

   this.Condition['Tags']=this.selectedConditionTag
    if(this.filterby!=undefined){
      this.isFilterChange =true
    }
    if(this.assigned[0].tags.length>0){
      let obj={
        id:this.assigned[0].tags.length,
        name:this.selectedConditionTag
      }
      this.assigned[0].tags.push(obj)
    }
    event.preventDefault();

    this.render.setElementClass(event.target,"active_t",true);

    let tag = this.tags.find( (item) => { return item.tid ==tid});

    let tag_index = this.assigned[0].tags.findIndex( (item)=> { return item.tid == tag.tid}); 
    
    if(tag_index == -1){

      this.assigned[0].tags.push(tag);
    }

    let filter = this.assigned[0].tags.filter( (item) => { 
      return (item.name =='OR' || item.name =='AND' || item.name =='NOT')
    });
    this.tagLength=filter.length+1


  }

  saveJob(event:any,tid:number){
       
    this.Condition['Job Title']=this.selectedConditionJob
    if(this.filterby!=undefined){
      this.isFilterChange =true
    }

    if(this.assigned[0].job_titles.length>0){
      let obj={
        id:this.assigned[0].job_titles.length,
        name:this.selectedConditionJob
      }
      this.assigned[0].job_titles.push(obj)
    }

    event.preventDefault();

    this.render.setElementClass(event.target,"active_t",true);

    let job_title = this.job_titles.find( (item) => { return item.tid ==tid});

    let country_index = this.assigned[0].job_titles.findIndex( (item)=> { return item.tid == job_title.tid}); 
    
    if(country_index == -1){

      this.assigned[0].job_titles.push(job_title);
    }

    let filter = this.assigned[0].job_titles.filter( (item) => { 
      return (item.name =='OR' || item.name =='AND' || item.name =='NOT')
    });
    this.jobLength=filter.length+1

  }


  saveCountry(event:any,tid:number){
       
  
    this.Condition['Country']=this.selectedConditionCountry

    if(this.assigned[0].countries.length>0){
      let obj={
        id:this.assigned[0].countries.length,
        name:this.selectedConditionCountry
      }
      this.assigned[0].countries.push(obj)
    }
   
    event.preventDefault();

    this.render.setElementClass(event.target,"active_t",true);

    let country = this.countries.find( (item) => { return item.tid ==tid});

    let country_index = this.assigned[0].countries.findIndex( (item)=> { return item.tid == country.tid}); 
    
    if(country_index == -1){

      this.assigned[0].countries.push(country);
    }
   
    if(this.filterby!=undefined && this.assigned[0].countries.length>0){
      this.isFilterChange =true
    }

    let filter = this.assigned[0].countries.filter( (item) => { 
      return (item.name =='OR' || item.name =='AND' || item.name =='NOT')
    });
    this.countryLength=filter.length+1

  }


   saveCompany(event:any,tid:number){

    this.Condition['Company']=this.selectedConditionCompany

    
  
    if(this.assigned[0].companies.length>0){
      let obj={
        id:this.assigned[0].companies.length,
        name:this.selectedConditionCompany
      }
      this.assigned[0].companies.push(obj);
    }

    if(this.filterby!=undefined){
      this.isFilterChange =true
    }

    event.preventDefault();

    this.render.setElementClass(event.target,"active_t",true);

    let company = this.companies.find( (item) => { return item.tid ==tid});


    let country_index = this.assigned[0].companies.findIndex( (item)=> { return item.tid == company.tid}); 
    
    if(country_index == -1){

      this.assigned[0].companies.push(company);
    }

    let filter = this.assigned[0].companies.filter( (item) => { 
      return (item.name =='OR' || item.name =='AND' || item.name =='NOT')
    });
    this.companyLength=filter.length+1
  }



 

 

  ngOnInit(){



    try{



      // this.time = new FormControl('', (control: FormControl) => {
      //   const value = control.value;
    
      //   if (!value) {
      //     return null;
      //   }
    
   
      //   return null;
      // });
    


      if(this.finalShare){




        this.invite = (this.newsletterI.send!=null)? this.newsletterI.send:[];

        this.inviteEmail = (this.newsletterI.send!=null)? this.newsletterI.send:[];

        this.fromName = (this.newsletterI.fromname!=null)? this.newsletterI.fromname:'';

        this.fromEmail = (this.newsletterI.fromemail!=null)? this.newsletterI.fromemail:'';

        this.showFrom = (this.fromName!='' || this.fromEmail!='');


        if(this.newsletterI.schedule!=null){


       //  this.time= {hour: parseInt(moment(this.newsletterI.schedule,'YYYY-MM-DD HH:m').format('HH')), minute: parseInt(moment(this.newsletterI.schedule,'YYYY-MM-DD HH:m').format('mm'))};
       this.time= {hour: parseInt(moment().format('HH')), minute: parseInt(moment().format('mm'))};

          this.adddate ='';

       
         // this.adddate=moment(this.newsletterI.schedule,'YYYY-MM-DD HH:m').format('YYYY-MM-DD');
         // this.adddate=moment().format('YYYY-MM-DD');

          
                   

        } else{

        

         this.adddate= moment(this.newsletterI.publish,'MMM DD ,YYYY ').format('YYYY-MM-DD');

       //   this.time= {hour: parseInt(moment(this.newsletterI.publish,'YYYY-MM-DD HH:m').format('HH')), minute: parseInt(moment(this.newsletterI.publish,'YYYY-MM-DD HH:m').format('mm'))};



        }
   

 
       



      }else{

        this.invite = (this.newsletterI.invite!=null)? this.newsletterI.invite:[];

        this.inviteEmail = (this.newsletterI.invite!=null)? this.newsletterI.invite:[];

      }
         



      
       if(this.newsletterI.deadline !='' && this.newsletterI.deadline!=null){

        $('.datepicker2').addClass('value-exists');

       } 




      let tokenA:any = (localStorage.getItem('token')!=undefined )?atob(localStorage.getItem('token')): 0;
  
      if(!tokenA) throw 'Error in parse';
      
      if(!JSON.parse(tokenA)) throw 'Error in json parse';
  
      tokenA = JSON.parse(tokenA);
          
      this.cd.filterData({'token':tokenA.token}).subscribe( (res)=>{

       

        if(res!=null && res!=undefined){

            this.countries = res.Country;
            this.companies = res.Company;
            this.job_titles = res['Job Title'];
            this.groups = res['Groups'];
            this.tags = res['Tags'];
            
            

        } else{
              
          this.toastr.success('Record Not Found  !', '', {timeOut: 3000});

        }



       });
  
        let data2 ={
          newsletter:this.newsletterI.id
        }
        this.cd.filterList({'token':tokenA.token,'details':data2}).subscribe( (result)=>{
  
        if(result.filters){

          result.filters.map((x)=>{
             x.isEdit=false;
          })

          this.filterNameList = result.filters
  
        }
  
       })
  
      


    }catch(e){


       this.toastr.success('Unauthorized Access  !', '', {timeOut: 3000});
       this._router.navigate(['/login']);
    }

 
        
  }



  ngAfterViewInit(): void {

   
  //    $('#datepairExample2 .time').timepicker({

  //      'showDuration': true,
 
  //      'timeFormat': 'g:ia',

 

  //  });

  $(".Favourite").click(function(){

    $(".drop-down-list").toggle();
  });


  


  $('#datepairExample1 .date').datepicker({

      format: 'yyyy-mm-dd',

      autoclose: true,
 
         startView: "date", 
         minViewMode: "date",
       //  startDate:  moment().format('YYYY-MM-DD'),  
      

  }).on('changeDate', function(e) {
      
      this.adddate = e.format();

   
      $('datepairExample1').addClass('value-exists')

      // important line 
      
       $('datepairExample1').datepicker('update');



  }.bind(this));


   
    $('#addemaildiv').click(function() {
      $('#addemail').focus();
    });

        
    $('input').not('.datepicker2').blur(function(event) {
      var inputValue = this.value;
      if (inputValue) {
        this.classList.add('value-exists');
      } else {
        this.classList.remove('value-exists');
      }
    });

   var end =moment(this.newsletterI.publish,"YYYY-MM-DD").subtract(1, 'day');

 

    $('.datepicker2').datepicker({
      
      autoclose: true,
      format: "yyyy-mm-dd",
      startView: "date", 
      minViewMode: "date", 
      startDate: '2000-01-01',  
      endDate: end.format("YYYY-MM-DD"),  
      datesDisabled: end.format("YYYY-MM-DD"),
     
    }).on('changeDate', function(e) {
 
      
      // this.callback(e.format());



       this.newsletterI.deadline =e.format();
         
    

       $('.datepicker2').addClass('value-exists')

      // important line 
      
       $('.datepicker2').datepicker('update');

       
       
       
  }.bind(this));


  }

  send_email(){
 

    //  this.newsletterI.invite = this.invite; 

     this.newsletterI.invite = this.inviteEmail;  

     this.passEntry.emit(this.newsletterI);


    
     


  }

  send_email_schedule(){

    // this.newsletterI.invite = this.invite;  

    this.newsletterI.invite = this.inviteEmail; 
   // let time_now =this.adddate+' '+this.time.hour+':'+this.time.minute;

    this.passEntry.emit({'invite':this.newsletterI,'schedulenow':true,'sendnow':false,'draft':false,'sdate':this.adddate,'time':this.time,'meridian':this.meridian,'fromname':this.fromName,'fromemail':this.fromEmail});



  }


  send_email_draft(){


    // this.newsletterI.invite = this.invite;  

    this.newsletterI.invite = this.inviteEmail; 

    this.passEntry.emit({'invite':this.newsletterI,'schedulenow':false,'sendnow':false,'draft':true,'sdate':'','time':'','meridian':this.meridian,'fromname':this.fromName,'fromemail':this.fromEmail});



  }

  send_email2(){
 

    // this.newsletterI.invite = this.invite;  
    this.newsletterI.invite = this.inviteEmail; 
 
   // let time_now =this.adddate+' '+this.time.hour+':'+this.time.minute;


 
 
   
   
    //if(moment(time_now,"YYYY-MM-DD HH:mm").isSameOrAfter(moment())){

       
    //  console.log('hhhhh',this.newsletterI)

     this.passEntry.emit({'invite':this.newsletterI,'schedulenow':false,'sendnow':true,'draft':false,'sdate':'','time':'','meridian':this.meridian,'fromname':this.fromName,'fromemail':this.fromEmail});



      
    //} else{

  


    //  this.toastr.success('Schedule date should be greater than current date time  !', '', {timeOut: 3000});
//
  //  }

 

 }


 saveFilterAs(){


  let country = [];

  this.assigned[0].countries.forEach( (items)=>{

      country.push(items.tid);
  });

  


  let company =  [];

  this.assigned[0].companies.forEach( (items)=>{

      company.push(items.tid);
  });

  
  let job_title = [];

  this.assigned[0].job_titles.forEach( (items)=>{

    job_title.push(items.tid);
  });

  let tag =  [];

  this.assigned[0].tags.forEach( (items)=>{

      tag.push(items.tid);
  });


  let group =  [];

  this.assigned[0].groups.forEach( (items)=>{

      group.push(items.tid);
  });

  if(country.length>0 || company.length>0 || job_title.length>0 || group.length>0 || tag.length>0){

    let records =  {
      "Country":country,
      "Company":company,
      "Job Title":job_title,
      "Groups":group,
      "Tags":tag,
      
  
    };
   

    try{

      let tokenA:any = (localStorage.getItem('token')!=undefined )?atob(localStorage.getItem('token')): 0;
  
      if(!tokenA) throw 'Error in parse';
      
      if(!JSON.parse(tokenA)) throw 'Error in json parse';
  
      tokenA = JSON.parse(tokenA);
      let data ={
        "name":this.filternameas,
        "newsletter":this.newsletterI.id,
        "filter":records
      }
          
      this.cd.filterList({'token':tokenA.token,'details':data}).subscribe( (res)=>{
  
       
          if(res!=null && res!=undefined){

            this.filternameas = ''
  
             this.toastr.success('Favourite filter name save sucessfully  !', '', {timeOut: 3000});
             let data2 ={
               newsletter:this.newsletterI.id
             }
             this.cd.filterList({'token':tokenA.token,'details':data2}).subscribe( (result)=>{

              if(result.filters){
                
                result.filters.map((x)=>{
                    x.isEdit=false;
                })

                this.filterNameList = result.filters
              }

             })

             $('.drop-down-list').hide();
              
          }else{

            this.toastr.warning('Favourite filter name not save !', '', {timeOut: 3000});
          }
  
       });
  
    }catch(e){
  
  
       this.toastr.error('Unauthorized Access  !', '', {timeOut: 3000});
       this._router.navigate(['/login']);
    }

  }else{
    this.toastr.warning('Please select filters before saving  !', '', {timeOut: 3000});
  }

  

}

filterEdit(indx:any,name:any){

  this.filterNameList[indx].isEdit =true

  this.filterUpdate = name

}

filterEditSave(indx:any,id:any){

  if(this.filterUpdate){
    this.filterNameList[indx].isEdit = false;
    try{

      let tokenA:any = (localStorage.getItem('token')!=undefined )?atob(localStorage.getItem('token')): 0;
  
      if(!tokenA) throw 'Error in parse';
      
      if(!JSON.parse(tokenA)) throw 'Error in json parse';
  
      tokenA = JSON.parse(tokenA);
  
      let data ={
        "name":this.filterUpdate,
        "id":id
      }
  
      this.cd.filterList({'token':tokenA.token,'details':data}).subscribe( (res)=>{
        if(res!=null && res!=undefined){
          this.filterUpdate = '';
          this.toastr.success('Favourite filter name save sucessfully  !', '', {timeOut: 3000});
               let data2 ={
                 newsletter:this.newsletterI.id
               }
               this.cd.filterList({'token':tokenA.token,'details':data2}).subscribe( (result)=>{
  
                if(result.filters){
                  
                  result.filters.map((x)=>{
                      x.isEdit=false;
                  })
  
                  this.filterNameList = result.filters
                }
  
           })

           $('.drop-down-list').hide();
           
        }
      })
  
      
  
    }catch(exec){
  
    }

  }else{
    this.toastr.warning('Favourite filter name can not be empty  !', '', {timeOut: 3000});
  }
  
  
  

}


filterDelete(id:any){

  try{

    let tokenA:any = (localStorage.getItem('token')!=undefined )?atob(localStorage.getItem('token')): 0;

    if(!tokenA) throw 'Error in parse';
    
    if(!JSON.parse(tokenA)) throw 'Error in json parse';

    tokenA = JSON.parse(tokenA);

    let data ={
      "archive":true,
      "id":id
    }

    this.cd.filterList({'token':tokenA.token,'details':data}).subscribe( (res)=>{
      if(res!=null && res!=undefined){
       
        this.toastr.success('Alias filter name deleted sucessfully  !', '', {timeOut: 3000});
             let data2 ={
               newsletter:this.newsletterI.id
             }
             this.cd.filterList({'token':tokenA.token,'details':data2}).subscribe( (result)=>{

              if(result.filters){
                
                result.filters.map((x)=>{
                    x.isEdit=false;
                })

                this.filterNameList = result.filters
              }

         })
         $('.drop-down-list').hide(); 
      }
    })

    

  }catch(exec){

  }

}

filterBy(obj){

  this.filterby = obj.name;
  this.appliedFilterId = obj.id

  this.assigned[0].countries =[]
  this.assigned[0].companies =[]
  this.assigned[0].job_titles =[]
  this.assigned[0].tags =[]
  this.assigned[0].groups =[]

  this.selectedCountry = obj.filter['Country']
  this.selectedCompany = obj.filter['Company']
  this.selectedJob =  obj.filter['Job Title']
  this.selectedTag = obj.filter['Tags']
  this.selectedGroup = obj.filter['Groups']

  obj.filter['Country'].map((x)=>{

     let country = this.countries.find( (item) => { return item.tid ==x});

    let country_index = this.assigned[0].countries.findIndex( (item)=> { return item.tid == country.tid}); 
    
    if(country_index == -1){

      this.assigned[0].countries.push(country);
    }
  })


  obj.filter['Company'].map((x)=>{
    
    let company = this.companies.find( (item) => { return item.tid ==x});

   let country_index = this.assigned[0].companies.findIndex( (item)=> { return item.tid == company.tid}); 
   
   if(country_index == -1){

     this.assigned[0].companies.push(company);
   }
  })


  obj.filter['Job Title'].map((x)=>{

    let job_title = this.job_titles.find( (item) => { return item.tid ==x});

    let country_index = this.assigned[0].job_titles.findIndex( (item)=> { return item.tid == job_title.tid}); 
    
    if(country_index == -1){

      this.assigned[0].job_titles.push(job_title);
    }

  })


  obj.filter['Tags'].map((x)=>{

    let tag = this.tags.find( (item) => { return item.tid ==x});

    let tag_index = this.assigned[0].tags.findIndex( (item)=> { return item.tid == tag.tid}); 
    
    if(tag_index == -1){
 
      this.assigned[0].tags.push(tag);
    }

  })


  obj.filter['Groups'].map((x)=>{

    let group = this.groups.find( (item) => { return item.tid ==x});

    let group_index = this.assigned[0].groups.findIndex( (item)=> { return item.tid == group.tid}); 
    
    if(group_index == -1){

      this.assigned[0].groups.push(group);
    }

  })
 


    let tokenA:any = (localStorage.getItem('token')!=undefined )?atob(localStorage.getItem('token')): 0;

    if(!tokenA) throw 'Error in parse';
    
    if(!JSON.parse(tokenA)) throw 'Error in json parse';

    tokenA = JSON.parse(tokenA);
        
    this.cd.filterContact({'token':tokenA.token,'details':obj.filter}).subscribe( (res)=>{

     
        if(res!=null && res!=undefined){

          if(res.length > 0){

            this.invite =res;

            this.inviteEmail = []; 

            res.map((x)=>{
              this.inviteEmail.push(x.email)
            })

          }else{

            this.invite =[];
            this.inviteEmail = [];
            this.toastr.success('Record Not Found  !', '', {timeOut: 3000});

          }

          $('.drop-down-list').hide();
          
        } else{
              
          this.invite =[];
          this.inviteEmail = [];
          
          this.toastr.success('Error in Record Fetch  !', '', {timeOut: 3000});

        }

      })

}


updateFilter(){

  let country = [];

  this.assigned[0].countries.forEach( (items)=>{

      country.push(items.tid);
  });

  


  let company =  [];

  this.assigned[0].companies.forEach( (items)=>{

      company.push(items.tid);
  });

  
  let job_title = [];

  this.assigned[0].job_titles.forEach( (items)=>{

    job_title.push(items.tid);
  });

  let tag =  [];

  this.assigned[0].tags.forEach( (items)=>{

      tag.push(items.tid);
  });


  let group =  [];

  this.assigned[0].groups.forEach( (items)=>{

      group.push(items.tid);
  });

  if(country.length>0 || company.length>0 || job_title.length>0 || group.length>0 || tag.length>0){

    let records =  {
      "Country":country,
      "Company":company,
      "Job Title":job_title,
      "Groups":group,
      "Tags":tag,
      
  
    };

    let tokenA:any = (localStorage.getItem('token')!=undefined )?atob(localStorage.getItem('token')): 0;
  
      if(!tokenA) throw 'Error in parse';
      
      if(!JSON.parse(tokenA)) throw 'Error in json parse';
  
      tokenA = JSON.parse(tokenA);
      let data ={
        "name":this.filterby,
        "newsletter":this.newsletterI.id,
        "filter":records,
        "id":this.appliedFilterId
      }
          
      this.cd.filterList({'token':tokenA.token,'details':data}).subscribe( (res)=>{
  
       
          if(res!=null && res!=undefined){

            this.isfilterUpdated = true
            this.isFilterChange = false;

            $('.drop-down-list').hide();
  
             this.toastr.success('Favourite filter name save sucessfully  !', '', {timeOut: 3000});
          }
      })  




  }

}

onChangeConditionCountry(event){
  this.selectedConditionCountry=event;
  this.Condition['Country']=this.selectedConditionCountry

  this.assigned[0].countries.map((x)=>{
    if(x.name=='OR'|| x.name=='AND' || x.name=='NOT'){
      x.name=this.selectedConditionCountry
    }
  })
  
}

onChangeConditionJob(event){
  this.selectedConditionJob=event
  this.Condition['Job Title']=this.selectedConditionJob

  this.assigned[0].job_titles.map((x)=>{
    if(x.name=='OR'|| x.name=='AND' || x.name=='NOT'){
      x.name=this.selectedConditionJob
    }
  })
}

onChangeConditionTag(event){
  this.selectedConditionTag=event
  this.Condition['Tags']=this.selectedConditionTag

  this.assigned[0].tags.map((x)=>{
    if(x.name=='OR'|| x.name=='AND' || x.name=='NOT'){
      x.name=this.selectedConditionTag
    }
  })
}

onChangeConditionGroup(event){
  this.selectedConditionGroup=event
  this.Condition['Groups']=this.selectedConditionGroup

  this.assigned[0].groups.map((x)=>{
    if(x.name=='OR'|| x.name=='AND' || x.name=='NOT'){
      x.name=this.selectedConditionGroup
    }
  })
}

onChangeConditionCompany(event){
  this.selectedConditionCompany=event
  this.Condition['Company']=this.selectedConditionCompany

  this.assigned[0].companies.map((x)=>{
    if(x.name=='OR'|| x.name=='AND' || x.name=='NOT'){
      x.name=this.selectedConditionCompany
    }
  })
}



 
}
